import { useContext, useState, createContext, useEffect } from 'react';

const defualtValue = {};

// initialize user context
const TimelineContextValue = createContext(defualtValue);
const TimelineContextSetState = createContext(() => null);

function TimelineProvider({ children, timeline = defualtValue }) {
  const [_timeline, setTimeline] = useState(timeline);

  useEffect(() => {
    setTimeline(timeline);
  }, [timeline]);
  return (
    <TimelineContextValue.Provider value={_timeline}>
      <TimelineContextSetState.Provider value={setTimeline}>{children}</TimelineContextSetState.Provider>
    </TimelineContextValue.Provider>
  );
}

function useTimelineState() {
  const timeline = useContext(TimelineContextValue);
  const setTimeline = useContext(TimelineContextSetState);
  const state = [timeline, setTimeline];
  return state;
}

function useTimelineValue() {
  const timeline = useContext(TimelineContextValue);
  return timeline;
}

function useTimelineSetState() {
  const setTimeline = useContext(TimelineContextSetState);
  return setTimeline;
}

export { TimelineProvider, useTimelineState, useTimelineValue, useTimelineSetState };
